"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productInfoShape = exports.mediaImageShape = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var mediaImageShape = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
  thumbnail: _propTypes["default"].string,
  primaryLink: _propTypes["default"].string,
  mediaType: _propTypes["default"].oneOf(['IMAGE', 'VIDEO', 'LPSURROUND']),
  caption: _propTypes["default"].string,
  largeSize: _propTypes["default"].shape({
    width: _propTypes["default"].number,
    height: _propTypes["default"].number
  })
})]);
exports.mediaImageShape = mediaImageShape;
var productInfoShape = _propTypes["default"].shape({
  brand: _propTypes["default"].string,
  siteProductName: _propTypes["default"].string
});
exports.productInfoShape = productInfoShape;
//# sourceMappingURL=_propTypes.js.map